module.exports = __webpack_public_path__ + "img/oneGreen.c4f3e199.jpg";